import { charactersList } from '@/mocks/characters';
import CharacterCard from '@/components/feature/CharacterCard';
import SectionHeading from '@/components/feature/SectionHeading';

const spotlight = charactersList.slice(0, 8);

export default function CharacterSpotlight() {
  return (
    <section className="mt-14 md:mt-16">
      <SectionHeading
        eyebrow="Characters"
        title="角色攻略精选"
        subtitle="点击角色卡片查看技能机制、天赋加点与配队思路"
        action={{ label: '全部角色', to: '/characters' }}
      />
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {spotlight.map((character) => (
          <CharacterCard key={character.id} character={character} />
        ))}
      </div>
    </section>
  );
}